<script>
import { InputCheckBox, InputText, InputRadio } from '@/components/Input';
import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';
import KeyWordTag from '@/components/KeywordTag/main.vue';

export default {
    name: 'CampaignFilterBasic',
    components: {
        InputCheckBox,
        InputText,
        DateNormal,
        Multiselect,
        KeyWordTag,
        InputRadio
    },
    props: {
        filter: {
            type: Object,
            required: true
        },
        search: {
            type: Object,
            required: true
        },
        campaignStatus: {
            type: Array,
            default: () => []
        },
        listDataMasterCampaignType: {
            type: Array,
            default: () => []
        },
        date_from: {
            type: Object,
            required: true
        },
        date_to: {
            type: Object,
            required: true
        },
        checkTodayCampaignStartDate: {
            type: Boolean,
            default: false
        },
        checkTodayCampaignEndDate: {
            type: Boolean,
            default: false
        },
        checkTodaySecretariatStartDate: {
            type: Boolean,
            default: false
        },
        checkTodaySecretariatEndDate: {
            type: Boolean,
            default: false
        },
        listDataMasterSaleStaf: {
            type: Array,
            default: () => []
        },
        listDataMasterInstructorStaf: {
            type: Array,
            default: () => []
        },
        sale_staff: {
            type: Array,
            default: () => []
        },
        person_in_charge: {
            type: Array,
            default: () => []
        },
        responsible_sub_persons: {
            type: Array,
            default: () => []
        },
        direction_staff: {
            type: Array,
            default: () => []
        },
        listTypeTitlePrize: {
            type: Array,
            default: () => []
        },
        configTotalWin: {
            type: Object,
            default: () => ({})
        },
        configKeywordOffice: {
            type: Object,
            default: () => ({})
        },
        configKeywordPhoneInformation: {
            type: Object,
            default: () => ({})
        },
        configKeywordMailInformation: {
            type: Object,
            default: () => ({})
        },
        listDataMasterOrderScope: {
            type: Array,
            default: () => []
        },
        listFilterScopeDepartment: {
            type: Array,
            default: () => []
        },
        listFilterScopeInquiry: {
            type: Array,
            default: () => []
        },
        listAllPartnersInquiry: {
            type: Array,
            default: () => []
        },
        listAllPartnersApplication: {
            type: Array,
            default: () => []
        },
        listAllPartnersSecretariat: {
            type: Array,
            default: () => []
        },
        listAllPartnersShipping: {
            type: Array,
            default: () => []
        },
        listAllTools: {
            type: Array,
            default: () => []
        },
        scope_partner_inquiry: {
            type: Array,
            default: () => []
        },
        scope_partner_application: {
            type: Array,
            default: () => []
        },
        scope_partner_secretariat: {
            type: Array,
            default: () => []
        },
        scope_partner_shipping: {
            type: Array,
            default: () => []
        },
        tool: {
            type: Array,
            default: () => []
        },
        configKeywordCode: {
            type: Object,
            default: () => ({})
        },
        configKeywordName: {
            type: Object,
            default: () => ({})
        },
        configKeywordOrderSource: {
            type: Object,
            default: () => ({})
        },
        configKeywordGenerateFile: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {};
    },

    methods: {
        handleChangeFilterInquiry(item) {
            this.$emit('changeFilterInquiry', item);
        },
        onClearDate(obj, key, isTime = false) {
            this.$set(obj, key, '');
            this.$set(obj, key + '_y', '');
            this.$set(obj, key + '_m', '');
            this.$set(obj, key + '_d', '');
            if (isTime) {
                this.$set(obj, key + '_full_time', '');
            }
        }
    },
    computed: {
        isDepartmentChecked() {
            return this.listDataMasterOrderScope.some((item) => item.value === '資料系' && this.filter.order_scope_large.includes(item.id));
        },
        isApplicationChecked() {
            return this.listDataMasterOrderScope.some((item) => item.value === '応募収集' && this.filter.order_scope_large.includes(item.id));
        },
        isSecretariatChecked() {
            return this.listDataMasterOrderScope.some((item) => item.value === '事務局関連' && this.filter.order_scope_large.includes(item.id));
        },
        isShippingChecked() {
            return this.listDataMasterOrderScope.some((item) => item.value === '発送' && this.filter.order_scope_large.includes(item.id));
        },
        isInquiryChecked() {
            return this.listDataMasterOrderScope.some((item) => item.value === 'お問い合わせ' && this.filter.order_scope_large.includes(item.id));
        }
    }
};
</script>

<template>
    <div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">CP番号</label>
            <div class="col-sm-9">
                <KeyWordTag :config="configKeywordCode" class="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">ステータス</label>
            <div class="col-sm-9">
                <div class="d-flex flex-wrap">
                    <div v-for="item in campaignStatus" :key="item.id + 's'">
                        <InputCheckBox
                            class="mr-3 mb-2"
                            :model.sync="filter.progress_status"
                            :id="`check-progress_status_${item.id}`"
                            :value="item.id"
                            :label="item.text"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">キャンペーン名</label>
            <div class="col-sm-9">
                <KeyWordTag :config="configKeywordName" class="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">キャンペーン種別</label>
            <div class="col-sm-9">
                <div class="d-flex">
                    <div v-for="item in listDataMasterCampaignType" :key="item.id + 's'">
                        <InputRadio
                            class="mr-4"
                            :model.sync="filter.campaign_type"
                            :name="`CampaignType`"
                            :id="`CampaignType-${item.id}`"
                            :value="item.id"
                            :label="item.value"
                        />
                    </div>
                    <div>
                        <InputRadio
                            class="mr-4"
                            :model.sync="filter.campaign_type"
                            :name="`CampaignType`"
                            id="CampaignType-null"
                            :value="'null'"
                            label="指定なし"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="filter.campaign_type && filter.campaign_type !== 'null'" class="form-group row">
            <label class="col-sm-3" for="validationCustom05">応募種別</label>
            <div class="col-sm-9">
                <div v-for="campaignType in listDataMasterCampaignType" :key="campaignType.id">
                    <div v-if="filter.campaign_type == campaignType.id">
                        <label for="" class="mb-2">{{ campaignType.value }}:</label>
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="item in campaignType.data"
                                :key="item.id"
                                class="mr-4"
                                :model.sync="filter.categories"
                                :name="`CampaignType`"
                                :id="`CampaignType-${item.id}`"
                                :value="item.id"
                                :label="item.value"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">キャンペーン開始日</label>
            <div class="col-sm-9">
                <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
                    <div class="d-flex align-items-center mb-2">
                        <DateNormal
                            :year.sync="date_from.campaign_start_date_y"
                            :month.sync="date_from.campaign_start_date_m"
                            :day.sync="date_from.campaign_start_date_d"
                            :full_date.sync="date_from.campaign_start_date"
                            :disabled="checkTodayCampaignStartDate"
                            :config="{
                                error: false
                            }"
                        ></DateNormal>
                        から
                        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'campaign_start_date')">
                            クリア
                        </button>
                    </div>
                    ～
                    <div class="d-flex align-items-center mb-2">
                        <DateNormal
                            :year.sync="date_to.campaign_start_date_y"
                            :month.sync="date_to.campaign_start_date_m"
                            :day.sync="date_to.campaign_start_date_d"
                            :full_date.sync="date_to.campaign_start_date"
                            :disabled="checkTodayCampaignStartDate"
                            :config="{
                                error: false
                            }"
                        ></DateNormal>
                        まで
                        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'campaign_start_date')">
                            クリア
                        </button>
                    </div>
                </div>
                <small>※年、年月のみの入力でも検索可能です。</small>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">キャンペーン終了日</label>
            <div class="col-sm-9">
                <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
                    <div class="d-flex align-items-center mb-2">
                        <DateNormal
                            :year.sync="date_from.campaign_end_date_y"
                            :month.sync="date_from.campaign_end_date_m"
                            :day.sync="date_from.campaign_end_date_d"
                            :full_date.sync="date_from.campaign_end_date"
                            :disabled="checkTodayCampaignEndDate"
                            :config="{
                                error: false
                            }"
                        ></DateNormal>
                        から
                        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'campaign_end_date')">
                            クリア
                        </button>
                    </div>
                    ～
                    <div class="d-flex align-items-center mb-2">
                        <DateNormal
                            :year.sync="date_to.campaign_end_date_y"
                            :month.sync="date_to.campaign_end_date_m"
                            :day.sync="date_to.campaign_end_date_d"
                            :full_date.sync="date_to.campaign_end_date"
                            :disabled="checkTodayCampaignEndDate"
                            :config="{
                                error: false
                            }"
                        ></DateNormal>
                        まで
                        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'campaign_end_date')">
                            クリア
                        </button>
                    </div>
                </div>
                <small>※年、年月のみの入力でも検索可能です。</small>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">事務局開始日</label>
            <div class="col-sm-9">
                <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
                    <div class="d-flex align-items-center mb-2">
                        <DateNormal
                            :year.sync="date_from.secretariat_start_date_y"
                            :month.sync="date_from.secretariat_start_date_m"
                            :day.sync="date_from.secretariat_start_date_d"
                            :full_date.sync="date_from.secretariat_start_date"
                            :disabled="checkTodaySecretariatStartDate"
                            :config="{
                                error: false
                            }"
                        ></DateNormal>
                        から
                        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'secretariat_start_date')">
                            クリア
                        </button>
                    </div>
                    ～
                    <div class="d-flex align-items-center mb-2">
                        <DateNormal
                            :year.sync="date_to.secretariat_start_date_y"
                            :month.sync="date_to.secretariat_start_date_m"
                            :day.sync="date_to.secretariat_start_date_d"
                            :full_date.sync="date_to.secretariat_start_date"
                            :disabled="checkTodaySecretariatStartDate"
                            :config="{
                                error: false
                            }"
                        ></DateNormal>
                        まで
                        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'secretariat_start_date')">
                            クリア
                        </button>
                    </div>
                </div>
                <small>※年、年月のみの入力でも検索可能です。</small>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">事務局終了日</label>
            <div class="col-sm-9">
                <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
                    <div class="d-flex align-items-center mb-2">
                        <DateNormal
                            :year.sync="date_from.secretariat_end_date_y"
                            :month.sync="date_from.secretariat_end_date_m"
                            :day.sync="date_from.secretariat_end_date_d"
                            :full_date.sync="date_from.secretariat_end_date"
                            :disabled="checkTodaySecretariatEndDate"
                            :config="{
                                error: false
                            }"
                        ></DateNormal>
                        から
                        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_from, 'secretariat_end_date')">
                            クリア
                        </button>
                    </div>
                    ～
                    <div class="d-flex align-items-center mb-2">
                        <DateNormal
                            :year.sync="date_to.secretariat_end_date_y"
                            :month.sync="date_to.secretariat_end_date_m"
                            :day.sync="date_to.secretariat_end_date_d"
                            :full_date.sync="date_to.secretariat_end_date"
                            :disabled="checkTodaySecretariatEndDate"
                            :config="{
                                error: false
                            }"
                        ></DateNormal>
                        まで
                        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="onClearDate(date_to, 'secretariat_end_date')">
                            クリア
                        </button>
                    </div>
                </div>
                <small>※年、年月のみの入力でも検索可能です。</small>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">発注元</label>
            <div class="col-sm-9">
                <KeyWordTag :config="configKeywordOrderSource" class="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">エンドクライアント</label>
            <div class="col-sm-9">
                <KeyWordTag :config="configKeywordGenerateFile" class="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">営業担当</label>
            <div class="col-sm-9">
                <Multiselect
                    :id="`select-sale_staff-default`"
                    :value="sale_staff"
                    :options="listDataMasterSaleStaf"
                    :config="{
                        trackBy: 'id',
                        label: 'name',
                        multiple: true,
                        closeOnSelect: false,
                        error: false,
                        isRemove: false,
                        loading: false
                    }"
                    @update:value="$emit('update:sale_staff', $event)"
                />
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">ディレクションメイン担当</label>
            <div class="col-sm-9">
                <Multiselect
                    :id="`select-person_in_charge-default`"
                    :value="person_in_charge"
                    :options="listDataMasterInstructorStaf"
                    :config="{
                        trackBy: 'id',
                        label: 'name',
                        multiple: true,
                        closeOnSelect: false,
                        error: false,
                        isRemove: false,
                        loading: false
                    }"
                    @update:value="$emit('update:person_in_charge', $event)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">ディレクションサブ1担当＆2担当</label>
            <div class="col-sm-9">
                <Multiselect
                    :id="`select-responsible_sub_persons-default`"
                    :value="responsible_sub_persons"
                    :options="listDataMasterInstructorStaf"
                    :config="{
                        trackBy: 'id',
                        label: 'name',
                        multiple: true,
                        closeOnSelect: false,
                        error: false,
                        isRemove: false,
                        loading: false
                    }"
                    @update:value="$emit('update:responsible_sub_persons', $event)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">ディレクション担当（メイン＆サブ担当）</label>
            <div class="col-sm-9">
                <Multiselect
                    :id="`select-direction_staff-default`"
                    :value="direction_staff"
                    :options="listDataMasterInstructorStaf"
                    :config="{
                        trackBy: 'id',
                        label: 'name',
                        multiple: true,
                        closeOnSelect: false,
                        error: false,
                        isRemove: false,
                        loading: false
                    }"
                    @update:value="$emit('update:direction_staff', $event)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">賞品種類</label>
            <div class="col-sm-9">
                <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                    <InputCheckBox
                        v-for="item in listTypeTitlePrize"
                        :key="item.id"
                        class="mr-4"
                        :model.sync="filter.prize_type"
                        :name="`prizeType-${item.id}`"
                        :id="`prizeType-${item.id}`"
                        :value="item.id"
                        :label="item.value"
                    />
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">総当選者数</label>
            <div class="col-sm-9 d-flex">
                <div class="d-flex align-items-center mr-2">
                    <InputText class="mr-2" :model.sync="date_from.total_win_from" :config.sync="configTotalWin" />
                    から
                </div>
                <div class="d-flex align-items-center">
                    <InputText class="mr-2" :model.sync="date_to.total_win_to" :config.sync="configTotalWin" />
                    まで
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">お問い合わせ事務局名</label>
            <div class="col-sm-9">
                <KeyWordTag :config="configKeywordOffice" class="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">事務局電話番号</label>
            <div class="col-sm-9">
                <KeyWordTag :config="configKeywordPhoneInformation" class="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">事務局メールアドレス</label>
            <div class="col-sm-9">
                <KeyWordTag :config="configKeywordMailInformation" class="" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">受注範囲大項目</label>
            <div class="col-sm-9">
                <div class="d-flex flex-wrap">
                    <InputCheckBox
                        v-for="orderLv1 in listDataMasterOrderScope"
                        :key="orderLv1.id"
                        class="mr-4 py-1"
                        :model.sync="filter.order_scope_large"
                        :id="`orderScopeLargeItem${orderLv1.id}`"
                        :name="`orderScopeLargeItem${orderLv1.id}`"
                        :value="orderLv1.id"
                        :label="orderLv1.value"
                    />
                </div>
            </div>
        </div>
        <div v-if="isDepartmentChecked" class="form-group row">
            <label class="col-sm-3" for="validationCustom05">受注範囲-資料系</label>
            <div class="col-sm-9">
                <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                    <InputCheckBox
                        v-for="item in listFilterScopeDepartment"
                        :key="item.id"
                        class="mr-4"
                        :model.sync="filter.order_scope_department"
                        :name="`orderScopeDepartment`"
                        :id="`orderScopeDepartment-${item.id}`"
                        :value="item.id"
                        :label="item.value"
                    />
                </div>
            </div>
        </div>
        <div v-if="isInquiryChecked" class="form-group row">
            <label class="col-sm-3" for="validationCustom05">受注範囲-お問い合わせ+詳細</label>
            <div class="col-sm-9">
                <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                    <InputCheckBox
                        v-for="item in listFilterScopeInquiry"
                        :key="item.id"
                        class="mr-4"
                        :model.sync="filter.order_scope_inquiry"
                        :name="`orderScopeInquiry`"
                        :id="`orderScopeInquiry-${item.id}`"
                        :value="item"
                        :label="item.value"
                        @change="handleChangeFilterInquiry(item)"
                    />
                </div>
                <div v-for="item in listFilterScopeInquiry" :key="item.id + 'label'">
                    <template v-if="filter.order_scope_inquiry.map((item) => item.id).includes(item.id) && item.data.length > 0">
                        <hr />
                        <label>{{ item.value }}:</label>
                        <div class="d-flex flex-wrap mb-2" style="gap: 10px">
                            <InputCheckBox
                                v-for="detail in item.data"
                                :key="detail.id"
                                class="mr-4"
                                :model.sync="filter.order_scope_inquiry_detail"
                                :name="`orderScopeInquiryDetail-${detail.id}`"
                                :id="`orderScopeInquiryDetail-${detail.id}`"
                                :value="detail"
                                :label="detail.value"
                            />
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">パートナー：受注範囲-お問い合わせ</label>
            <div class="col-sm-9">
                <Multiselect
                    :id="`select-scope_partner_inquiry-default`"
                    :value="scope_partner_inquiry"
                    :options="listAllPartnersInquiry"
                    :config="{
                        trackBy: 'id',
                        label: 'name',
                        multiple: true,
                        closeOnSelect: false,
                        error: false,
                        isRemove: false,
                        loading: false
                    }"
                    @update:value="$emit('update:scope_partner_inquiry', $event)"
                />
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">パートナー：受注範囲-事務局関連</label>
            <div class="col-sm-9">
                <Multiselect
                    :id="`select-scope_partner_secretariat-default`"
                    :value="scope_partner_secretariat"
                    :options="listAllPartnersSecretariat"
                    :config="{
                        trackBy: 'id',
                        label: 'name',
                        multiple: true,
                        closeOnSelect: false,
                        error: false,
                        isRemove: false,
                        loading: false
                    }"
                    @update:value="$emit('update:scope_partner_secretariat', $event)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">パートナー：受注範囲-発送</label>
            <div class="col-sm-9">
                <Multiselect
                    :id="`select-scope_partner_shipping-default`"
                    :value="scope_partner_shipping"
                    :options="listAllPartnersShipping"
                    :config="{
                        trackBy: 'id',
                        label: 'name',
                        multiple: true,
                        closeOnSelect: false,
                        error: false,
                        isRemove: false,
                        loading: false
                    }"
                    @update:value="$emit('update:scope_partner_shipping', $event)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3" for="validationCustom05">ツール：受注範囲-応募収集<br />ツール：受注範囲-事務局関連</label>
            <div class="col-sm-9">
                <Multiselect
                    :id="`select-tool-default`"
                    :value="tool"
                    :options="listAllTools"
                    :config="{
                        trackBy: 'id',
                        label: 'tool',
                        multiple: true,
                        closeOnSelect: false,
                        error: false,
                        isRemove: false,
                        loading: false
                    }"
                    @update:value="$emit('update:tool', $event)"
                />
            </div>
        </div>
    </div>
</template>
